var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 28,
    height: 28,
    rx: 5,
    fill: "#272E49"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8672 8.55469C24.1133 8.82812 24.25 9.12891 24.25 9.48438V16.8125C24.25 17.1953 24.1133 17.4961 23.8672 17.7422C23.5938 18.0156 23.293 18.125 22.9375 18.125H20.75V19.4375C20.75 19.8203 20.6133 20.1211 20.3672 20.3672C20.0938 20.6406 19.793 20.75 19.4375 20.75H13.3125C12.9297 20.75 12.6289 20.6406 12.3828 20.3672C12.1094 20.1211 12 19.8203 12 19.4375V10.6875C12 10.332 12.1094 10.0312 12.3828 9.75781C12.6289 9.51172 12.9297 9.375 13.3125 9.375H15.5V8.0625C15.5 7.70703 15.6094 7.40625 15.8828 7.13281C16.1289 6.88672 16.4297 6.75 16.8125 6.75H21.5156C21.8711 6.75 22.1719 6.88672 22.4453 7.13281L23.8672 8.55469ZM19.2734 19.4375C19.3008 19.4375 19.3281 19.4375 19.3828 19.3828C19.4102 19.3555 19.4375 19.3281 19.4375 19.2734V18.125H16.8125C16.4297 18.125 16.1289 18.0156 15.8828 17.7422C15.6094 17.4961 15.5 17.1953 15.5 16.8125V10.6875H13.4766C13.4219 10.6875 13.3945 10.7148 13.3672 10.7422C13.3125 10.7969 13.3125 10.8242 13.3125 10.8516V19.2734C13.3125 19.3281 13.3125 19.3555 13.3672 19.3828C13.3945 19.4375 13.4219 19.4375 13.4766 19.4375H19.2734ZM22.7734 16.8125C22.8008 16.8125 22.8281 16.8125 22.8828 16.7578C22.9102 16.7305 22.9375 16.7031 22.9375 16.6484V11.125H20.5312C20.3398 11.125 20.1758 11.0703 20.0664 10.9336C19.9297 10.8242 19.875 10.6602 19.875 10.4688V8.0625H16.9766C16.9219 8.0625 16.8945 8.08984 16.8672 8.11719C16.8125 8.17188 16.8125 8.19922 16.8125 8.22656V16.6484C16.8125 16.7031 16.8125 16.7305 16.8672 16.7578C16.8945 16.8125 16.9219 16.8125 16.9766 16.8125H22.7734ZM22.9375 9.8125V9.53906C22.9375 9.51172 22.9102 9.48438 22.8828 9.42969L21.5703 8.11719C21.5156 8.08984 21.4883 8.0625 21.4609 8.0625H21.1875V9.8125H22.9375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.be9b5d95.svg";
export { ForwardRef as ReactComponent };